import { ThemeConfig } from '@chakra-ui/react'
import { ColorPalette } from '~/themes/colors/colorPalette'
import { themeColorSections } from '~/themes/colors/colors'

import { TextStyles } from './textStyles/defaultTextStyles'

export enum ThemeColorMode {
  default = 'light',
  dark = 'dark',
}

export type MangoTheme = {
  breakpoints: Record<string, string>
  textStyles: TextStyles
  colors: ColorPalette
  config?: ThemeConfig
  semanticTokens: {
    colors: typeof themeColorSections
  }
  components: Record<string, { components: Record<string, unknown> }>
}
